import { SIDEBAR_WIDTH } from "@/types/common";
import { Box, Typography } from "@mui/material";
import React from "react";

interface PageLayoutProps {
  title?: string;
  children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ title, children }) => {
  return (
    <Box
      sx={{
        pt: 3,
        pb: 8,
        px: 6,
        boxSizing: "border-box",
        mx: "auto",
        width: "100%",
        minWidth: `calc(1280px - ${SIDEBAR_WIDTH}px)`,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflowY: "auto",
      }}
    >
      {title && (
        <Typography variant='h5' sx={{ mb: 2, fontWeight: 500 }}>
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default PageLayout;
